
import components from '@/components'
export default {
  name: 'ExpansionPanel',
  components,
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  methods: {
    scrollToTop(e) {
      const ua = window.navigator.userAgent
      const msie = ua.indexOf('MSIE ')
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        return false
      } else {
        if (
          e.target.closest('.v-expansion-panel-content') ||
          e.target.className === 'v-expansion-panel-content'
        ) {
          return false
        }
        setTimeout(() => {
          const scrollTarget =
            e.target.className === 'v-expansion-panel-header'
              ? e.target
              : e.target.offsetParent
          this.$vuetify.goTo(scrollTarget)
        }, 300)
      }
    }
  }
}
